module.exports = __webpack_public_path__ + "media/images/technology/Gentier 96E-32bce12863ee2b2c9a9227c3814449ed.png";